/**
 * Search typeahead results panel.
 */
export default {
  parts: [
    'wrap',
    'section',
    'heading',
    'list',
    'item',
    'itemInner',
    'itemImage',
    'itemInfo',
    'itemTitle',
    'itemTag',
    'viewAll',
  ],
  baseStyle: {
    wrap: {
      alignItems: 'stretch',
      display: 'flex',
      flexDirection: 'column',
      gap: '48px',
      maxW: {base: 'full', md: '619px'},
      minW: 0,
      width: 'full',
    },
    section: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      width: 'full',
    },
    heading: {
      color: 'rgba(56, 56, 56, 0.6)',
      fontSize: {base: '10px', md: '10px'},
      fontWeight: 'semibold',
      letterSpacing: {base: '2px', md: '2.4px'},
      lineHeight: '1.2',
      textTransform: 'uppercase',
      width: 'full',
    },
    list: {
      alignItems: 'stretch',
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      width: 'full',
    },
    item: {
      alignItems: 'center',
      bg: 'background.secondary',
      display: 'flex',
      height: 'auto',
      justifyContent: 'stretch',
      minH: '75px',
      pb: {base: 4, md: '13px'},
      pl: {base: 4, md: 5},
      pr: {base: 4, md: 7.5},
      pt: {base: 4, md: '14px'},
      rounded: 'none',
      width: 'full',
      _active: {
        bg: 'background.secondary',
      },
      _focus: {
        boxShadow: 'none',
      },
      _focusVisible: {
        boxShadow: '0 0 0 3px rgba(27, 26, 24, 0.2)',
      },
      _hover: {
        bg: 'background.secondary',
        opacity: 0.92,
      },
    },
    itemInner: {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      gap: {base: 2, md: 2.5},
      minW: 0,
      width: 'full',
    },
    itemImage: {
      backgroundColor: 'greyscale90Alpha.10',
      flexShrink: 0,
      h: '48px',
      overflow: 'hidden',
      position: 'relative',
      w: '108px',
    },
    itemInfo: {
      alignItems: {base: 'flex-start', md: 'center'},
      display: 'flex',
      flex: 1,
      flexDirection: {base: 'column', md: 'row'},
      gap: {base: 2, md: 4},
      justifyContent: 'flex-start',
      minW: 0,
      textAlign: 'left',
    },
    itemTitle: {
      color: 'brandColors.darkCharcoal',
      flex: {base: 'unset', md: 1},
      fontSize: 'md',
      fontWeight: 500,
      lineHeight: '1.4',
      minW: 0,
      textAlign: 'left',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      sx: {
        '& span': {
          fontSize: 'inherit',
          fontWeight: 'inherit',
          lineHeight: 'inherit',
        },
        b: {fontWeight: 500},
        strong: {fontWeight: 500},
      },
    },
    itemTag: {
      color: 'rgba(0, 0, 0, 0.4)',
      flexShrink: 1,
      fontSize: 'xs',
      fontWeight: 'normal',
      lineHeight: '1.2',
      maxW: {base: 'full', md: '170px'},
      minW: 0,
      overflow: 'hidden',
      textAlign: 'left',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    viewAll: {
      alignSelf: 'flex-start',
      color: 'brandColors.primaryDarkLinen',
      cursor: 'pointer',
      display: 'inline-block',
      fontSize: {base: 'md', md: 'md'},
      fontStyle: 'normal',
      fontWeight: '500',
      letterSpacing: 0,
      lineHeight: {'base': '140%', 'md': '130%'},
      m: 0,
      p: 0,
      width: 'auto',
      wordBreak: 'break-word',
      _hover: {
        opacity: 0.85,
      },
    },
  },
};
